import { useEffect, useContext } from 'react'
import { GlobalContext } from '../App'

const socketAddress = `wss://qiklook.com/QikLook/framework/ws`

const Websocket = () => {
  const { socketReceive, dispatch } = useContext(GlobalContext)

  useEffect(() => {
    const socket = new WebSocket(socketAddress)

    socket.onopen = () => null

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data)
      socketReceive(data)
    }

    socket.onerror = () => null

    socket.onclose = () => null

    return () => {
      socket.close()
    }
  }, [socketReceive, dispatch])

  return null // Este componente não precisa renderizar nada
}

export default Websocket
